/**
 * Trigger Master Select on variant change
 */
const triggerMasterSelectOnVariantChange = () => {
	$('.js-productOption').on('change', function() {
		changeMaterSelect();
	});

	$('.js-productRadioOption input').on('change', function() {
		changeMaterSelect();
	});

	$('.js-dropdown-material-options').closest('form').find('[name="properties[Pattern]"]').on('change', function() {
		changeMaterSelect();
	});

	$('.js-productSizes').on('change', function() {
		changeMaterSelect();
	});
}

triggerMasterSelectOnVariantChange();

const changeMaterSelect = () => {
	const $masterSelect = $('.js-productMasterSelect');
	let targetOption = '';

	$('.js-productOption').each(function(index, el) {
		const $this = $(this);
		const position = $this.data('position');
		const value = $this.val();

		targetOption = targetOption + `[data-option-${position}="${value}"]`;
	});

	targetOption = targetOption + `[data-option-${$('.js-productRadioOption').data('position')}="${$('.js-productRadioOption').find('input:checked').val()}"]`;

	targetOption = targetOption + `[data-product-size="${$('.js-productSizes').val()}"]`;

	const masterSelectValue = $masterSelect.find(targetOption).val();

	$masterSelect.val(masterSelectValue);

	$masterSelect.trigger('change');
}
